import { ReferralDto } from 'common/api';

type MrrDisplayParams = {
  isEnUs: boolean;
  siterxFlagEnabled: boolean;
  seqsterFlagEnabled: boolean;
  siterxOptin?: boolean;
  seqsterOptin?: boolean;
  studySiteStatus?: ReferralDto.studySiteStatus;
  medicalRecordsRequestStatus?: ReferralDto.medicalRecordsRequestStatus;
  isRequesting: boolean;
  isViewing?: boolean;
};

type MrrMessage = {
  id: string;
  defaultMessage: string;
};

export type MrrStatusLabel = {
  label: MrrMessage;
  note?: MrrMessage;
};

export function getMrrDisplay({
  isEnUs,
  siterxFlagEnabled,
  seqsterFlagEnabled,
  siterxOptin,
  seqsterOptin,
  studySiteStatus,
  medicalRecordsRequestStatus,
  isRequesting,
  isViewing = false,
}: MrrDisplayParams) {
  const showSeqsterRequestLink =
    studySiteStatus === ReferralDto.studySiteStatus.ACTIVE &&
    (!medicalRecordsRequestStatus ||
      medicalRecordsRequestStatus ===
        ReferralDto.medicalRecordsRequestStatus.NOT_FOUND) &&
    !isRequesting;

  if (siterxOptin && seqsterOptin) {
    return {
      showSiterxMrr: false,
      showSeqsterMrr: false,
      showSeqsterRequestLink,
      showSeqsterViewLink: false,
    };
  }

  const showSeqsterMrr = Boolean(seqsterFlagEnabled && seqsterOptin && isEnUs);

  return {
    showSiterxMrr: Boolean(siterxFlagEnabled && siterxOptin && isEnUs),
    showSeqsterMrr,
    showSeqsterRequestLink,
    showSeqsterViewLink:
      showSeqsterMrr &&
      medicalRecordsRequestStatus ===
        ReferralDto.medicalRecordsRequestStatus.AVAILABLE &&
      !isViewing,
  };
}

const MRR_STATUS_LABELS: Record<
  ReferralDto.medicalRecordsRequestStatus,
  MrrStatusLabel
> = {
  [ReferralDto.medicalRecordsRequestStatus.PENDING]: {
    label: {
      id: 'is.request_medical_records.status.pending',
      defaultMessage: 'Pending',
    },
    note: {
      id: 'is.request_medical_records.status.pending.note',
      defaultMessage: 'Can take up to 72h',
    },
  },
  [ReferralDto.medicalRecordsRequestStatus.AVAILABLE]: {
    label: {
      id: 'is.request_medical_records.status.available',
      defaultMessage: 'Available',
    },
  },
  [ReferralDto.medicalRecordsRequestStatus.NOT_FOUND]: {
    label: {
      id: 'is.request_medical_records.status.not_found',
      defaultMessage: 'Not found',
    },
  },
  [ReferralDto.medicalRecordsRequestStatus.FAILED]: {
    label: {
      id: 'is.request_medical_records.status.failed',
      defaultMessage: 'Failed',
    },
  },
};

export function getMrrStatusLabel(
  status: ReferralDto.medicalRecordsRequestStatus
): MrrStatusLabel {
  return MRR_STATUS_LABELS[status];
}

export function hasRecordedSeqsterMrConsent(
  seqsterMrConsentReceived?: boolean
): boolean {
  return seqsterMrConsentReceived === true;
}

export function seqsterConsentWasStored(statusCode: number): boolean {
  return statusCode === 400 || statusCode === 503;
}
